import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { s as slotFilled } from './p-rUtJRH95.js';
import { d as defineCustomElement$7 } from './p-BbTg3Car.js';
import { d as defineCustomElement$6 } from './p-Dpb0Xahb.js';
import { d as defineCustomElement$5 } from './p-Da2lAZSv.js';
import { d as defineCustomElement$4 } from './p-CuEVPYij.js';
import { d as defineCustomElement$3 } from './p-CFAyJ2yW.js';
import { d as defineCustomElement$2 } from './p-ClSUnmWE.js';

const expandableToggleCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;border-radius:.375rem;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host(:not([nested])){border:1px solid var(--jw-theme-surface-border-border-color)}:host(:not([nested])) .header{background-color:var(--jw-theme-surface-tile-bg-color);color:var(--jw-theme-surface-text-default-color)}:host(:not([nested])) .header-description{color:var(--jw-theme-surface-text-description-color)}:host(:not([nested])) wui-icon{margin-top:.25rem}:host(:not([nested])) h3{font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem}:host(:not([nested])) .body{background-color:var(--jw-theme-surface-elevated-default-bg-color)}:host([nested]) .header{background-color:var(--jw-theme-surface-level1-default-bg-color)}:host([nested]) .header-description{color:var(--jw-theme-surface-text-description-color)}:host([nested]) wui-icon{margin-top:.125rem}:host([nested]) h3{font-family:Open Sans;font-size:.875rem;font-weight:600;letter-spacing:-.0004em;line-height:1.25rem}:host([nested]) .body{background-color:var(--jw-theme-surface-level1-default-bg-color)}.header{border-radius:.375rem;gap:1rem;padding:1rem;transition:border-radius .35s ease,background-color .35s ease,color .35s ease}.header,.header-container{display:flex;flex-direction:column}.header-container{gap:.125rem}.header-description{font-family:Open Sans;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1rem}wui-icon{align-self:flex-start}.title{gap:2rem;justify-content:space-between}.icon-title,.title{align-items:center;display:flex}.icon-title{flex:1;flex-direction:row;gap:.5rem}h3{margin:0;padding:0}.body{border-radius:.375rem;display:none;padding:1rem;transition:border-radius .35s ease}:host([checked]) .header{background-color:var(--jw-theme-info-muted-message-bg-color);color:var(--jw-theme-info-muted-message-color)}:host([checked]) .header:has(+.body){border-bottom-left-radius:0;border-bottom-right-radius:0}:host([checked]) .body{border-top-left-radius:0;border-top-right-radius:0;display:flex}:host([disabled]) .header{background-color:var(--jw-theme-neutral-muted-message-bg-color);color:var(--jw-theme-form-field-disabled-color);cursor:not-allowed}:host([disabled]) .header-description{color:var(--jw-theme-surface-text-description-color);cursor:not-allowed}:host([disabled]) .description{color:var(--jw-theme-surface-text-description-color);cursor:not-allowed}";

const WuiExpandableToggle$1 = /*@__PURE__*/ proxyCustomElement(class WuiExpandableToggle extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * If the input is disabled
         */
        this.disabled = false;
        /**
         * If the input is nested
         */
        this.nested = false;
    }
    toggle(checked = !this.checked) {
        if (this.disabled) {
            return;
        }
        this.checked = checked;
        this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
    }
    render() {
        return (h(Host, { key: '023fb8493ee5d164eacf0ae80d9da71ce7ece099' }, h("div", { key: '0eee47be0aceecb531cbd4e2fb3045456e166bcc', class: "header" }, h("div", { key: 'e6c07d710c07a9d75f01a7f34103aefeabdbb0c5', class: "title" }, h("div", { key: '985dbd80270e613837ca421b6b87d6294fea6144', class: "icon-title" }, this.iconName && h("wui-icon", { key: 'a11da4f0ba985b1ca5b3ad33da697b5b6ab2366d', name: this.iconName }), h("div", { key: '0019aa4427eae4d2a884f72f14b99e829028b6b2', class: "header-container" }, h("h3", { key: '535e8827f02a433bdbd909933d716fcc4ba6fb83' }, this.header), this.headerDescription && h("div", { key: 'e9983674a34a4d8b54654aa0b6810b47283a9b43', class: "header-description" }, this.headerDescription))), h("wui-toggle", { key: '8f370c8fcc09b62a718fdfdc02e8e61126557bec', onInput: (e) => {
                const target = e.currentTarget;
                // Emit our own event
                e.preventDefault();
                e.stopPropagation();
                this.toggle(target?.checked);
            }, checked: this.checked, disabled: Boolean(this.disabled), "data-test": "set-toggle-value" })), this.disabledMsg && (h("div", { key: 'ad9c451e20b02e2cbc4c155fe8cdc9b376f6659a', class: "description", "data-test": "show-toggle-disabled-warning" }, this.disabledMsg))), slotFilled(this.elm) && (h("div", { key: 'fe058a957cf3aaaf32c757c9f1aa77d7821ac254', class: "body" }, h("slot", { key: '05dcb09551ceb8ab228d1cf745f9ababbef558a9' })))));
    }
    get elm() { return this; }
    static get style() { return expandableToggleCss; }
}, [257, "wui-expandable-toggle", {
        "checked": [1540],
        "header": [1],
        "headerDescription": [1, "header-description"],
        "disabled": [516],
        "disabledMsg": [1, "disabled-msg"],
        "iconName": [1, "icon-name"],
        "nested": [516]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-expandable-toggle", "wui-box", "wui-form-field", "wui-icon", "wui-toggle", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-expandable-toggle":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiExpandableToggle$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-toggle":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiExpandableToggle = WuiExpandableToggle$1;
const defineCustomElement = defineCustomElement$1;

export { WuiExpandableToggle, defineCustomElement };
